<div class="popup">
    <p *ngIf="success == true" class="success-popup">Saved!</p>
    <p *ngIf="success == false" class="reject-popup">{{errorText}}</p>
</div>

<div class="container" *ngIf="isSkeltonLoad">
    <div class="row">
        <div class="col main oldpassword" *ngFor="let item of skeltonArray">
            <form class="form-skelton">
                <div class="headingSkelton"></div>
                <div class="textSkeltonBig"></div>
                <div class="textSkeltonMed"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="buttonSkelton"></div>
            </form>
        </div>
    </div>
</div>
<div class="container" *ngIf="!isSkeltonLoad">
    <div class="row">
        <div class="col main">
            <form [formGroup]="confirmForm" [ngStyle]="{ height: windowWidth}">
                <p class="heading">Close Account</p>
                <p class="warning">Warning: closing your account is irreversible. It deletes all of your bookmarks,
                    and submission data.</p>
                <div class="mobile-warning">
                    <p class="warning-heading">Warning</p>
                    <p class="warning-txt">Closing your account is irreversible.<br> It deletes all of your
                        bookmarks,<br>
                        and submission data.</p>
                    <div class="password-mobile" *ngIf="emailUser">
                        <label class="label">Enter Your Password</label>
                        <div class="field">
                            <input class="input-text" id="input-password" type="password" formControlName="password"
                                placeholder="Password">
                            <span class="input-text-required"
                                *ngIf="confirmForm.get('password').errors?.required && (confirmForm.get('password').dirty || confirmForm.get('password').touched)">
                                Please enter a password </span>
                        </div>
                    </div>
                </div>
                <div class="password" *ngIf="emailUser">
                    <label class="label">Enter Your Password</label>
                    <div class="field">
                        <input class="input-text" id="input-password" formControlName="password" type="password"
                            placeholder="Password">
                        <span class="input-text-required"
                            *ngIf="confirmForm.get('password').errors?.required && (confirmForm.get('password').dirty || confirmForm.get('password').touched)">
                            Please enter a password </span>
                    </div>
                </div>

                <div class="save-div">
                    <button class="save" type="submit" (click)="openConfirmModal()">
                        <span *ngIf="isloading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Delete Account
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- confirm modal -->

<div class="modal-popup" id="modal-popup-confirm" *ngIf="showconfirmModal">
    <div class="confirm-popup-content popup-content-confirm">
        <div class="popup-content-confirm-margin">
            <h1>Sure you want to <br> delete your account forever?</h1>
        </div>
        <button [disabled]="isRemoving" type="button" class="yes-button" (click)="deleteAccount()">
            <div *ngIf="isRemoving" class="spinner-border removing-spinner" role="status">
                <span class="sr-only">{{constants.LOADING_TEXT}}</span>
            </div>
            <div *ngIf="!isRemoving">{{constants.YES}}</div>
        </button>
        <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
            {{constants.CANCEL}}
        </button>
    </div>
</div>